import { createContext } from 'react'
import { TUsersContext } from './types'

export const UsersContext = createContext<TUsersContext>({

})